import { render, staticRenderFns } from "./Wp_my_change_account.vue?vue&type=template&id=19004250&scoped=true&"
import script from "./Wp_my_change_account.vue?vue&type=script&lang=js&"
export * from "./Wp_my_change_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19004250",
  null
  
)

export default component.exports